export default "__VITE_ASSET__CJ8Wj$Y4__"